var pro = function (column) {
    var $column = column.$el;
    var $setting = $column.find('.ac-column-setting--pro');
    $setting.each(function () {
        var $container = jQuery(this);
        $container.find('input').on('click', function (e) {
            e.preventDefault();
            $container.find('[data-ac-open-modal]').trigger('click');
        });
    });
};
export default pro;
